import React, { useMemo } from "react";
import { Field, useFormState } from "react-final-form";
import { makeStyles, Typography } from "@material-ui/core";
import InputLabel from "@material-ui/core/InputLabel";
import clsx from "clsx";
import WeduRadio from "../../../../../components/WeduRadio/WeduRadio";
import InfoIcon from "../../../../../components/InfoIcon";
import { ProgramType } from "../../../constants";

const useStyles = makeStyles((theme) => ({
  label: {
    marginTop: 8,
    marginBottom: 16,
    fontSize: 18,
    fontWeight: "bold",
    color: "#535358",
  },
  container: {
    width: 199,
  },
  radioGroup: {
    display: "flex",
    justifyContent: "flex-start",
    "& > label + label": {
      marginLeft: 40,
    },
  },
  asterisk: {
    color: "#535358",
    lineHeight: "inherit",
    fontSize: 16,
    fontWeight: "normal",
    marginLeft: 3,
  },
  hasError: {
    color: theme.palette.error.main,
  },
  helperText: {
    height: 0,
    fontSize: 14,
    fontWeight: 500,
    textAlign: "right",
    color: theme.palette.error.main,
  },
}));

const ProgramTypeInput = ({ name }) => {
  const classes = useStyles();

  const { submitFailed, dirtySinceLastSubmit, invalid } = useFormState();
  const hasError = useMemo(
    () => invalid && submitFailed && !dirtySinceLastSubmit,
    [invalid, dirtySinceLastSubmit, submitFailed],
  );

  const formState = useFormState();
  const helperText =
    formState.submitErrors?.[name]?.programType;

  return (
    <div>
      <div className={classes.label}>
        Program Type
        <Typography
          className={clsx(
            classes.asterisk,
            hasError && helperText && classes.hasError,
          )}
          component={"span"}
          variant={"subtitle2"}
        >
          *
        </Typography>
        <InfoIcon
          text="You need to choose either of them. If you have both you need to create each separately."
          portalMode={false}
        />
      </div>
      <div className={classes.container}>
        <div className={classes.radioGroup}>
          <Field
            name={`${name}.programType`}
            component={WeduRadio}
            type="radio"
            value={ProgramType.ON_CAMPUS}
            label="On Campus"
          />
          <Field
            name={`${name}.programType`}
            component={WeduRadio}
            type="radio"
            value={ProgramType.ONLINE}
            label="Online"
          />
        </div>
        {hasError && (
          <InputLabel className={classes.helperText}>{helperText}</InputLabel>
        )}
      </div>
    </div>
  );
};

export default ProgramTypeInput;
